<div class="account-shell__loading animated faster fadeIn" *ngIf="ProfileLoading">
  <div class="ui-loader ui-loader__page-light"></div>
</div>

<div class="account-shell__content"
  ngClass="{{ProfileLoading ? 'loading' : ''}}">

  <div class="pg-wrapper" *ngIf="ProfileSubject | async as Profile">

    <form [formGroup]="ProfileForm" (keydown.enter)="$event.preventDefault()" autocomplete="off">

      <div class="account-shell__content-wrapper" *ngIf="!Profile.emailConfirmed"
        ngClass="{{(deviceValue | async) === DTypes.Mobile ? '' : 'pl-3 pr-3'}}">
        <div class="row">
          <div class="profile__confirmed status-warning">
            <div class="grid align-items-center justify-content-center flex-column">
              <div class="col-12 col-sm-12 text-center">
                <span class="mr-icon mr-icon-status-error mt-2 mb-4"></span>
                <h5>Ваш профиль не подтвержден!</h5>
                <p class="mt-2 mb-6">
                  Для подтверждения учетной записи пройдите по ссылке в письме, отправленного на почту при регистрации.<br/>
                  Если Вам <strong>не пришло на почту письмо</strong>, Вы можете отправить его повторно.
                </p>
              </div>
              <div class="col-3 col-sm-6">
                <button class="ui-buttons ui-buttons__blue-large" (click)="onReconfirmProfile()"
                  ngClass="{{ProfileReconfirmModify ? 'disabled' : ''}}">
                  Отправить
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="account-shell__content-wrapper"
        ngClass="{{(deviceValue | async) === DTypes.Mobile ? '' : 'pl-3 pr-3'}}">
        <div class="account-shell__content-subtitle">
          <h5>Личная информация</h5>
          <div class="grid align-items-start pt-2">
            <p class="txt-require pr-1">*</p>
            <p class="txt-caption__large">— Поля отмеченные звездочкой обязательны для заполнения и не могут быть пустыми.</p>
          </div>
        </div>
      </div>

      <div class="account-shell__content-wrapper">
        <div class="grid align-items-start justify-content-center"
          ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : ''}}">

          <div class="col-4 col-sm-12">
            <div class="account-shell__avatar">
              <div class="account-shell__avatar-event">
                <div class="account-shell__avatar-event__clear" *ngIf="ProfileAvatar" (click)="onUploadAvatarClear()">
                  <i class="pi pi-times-circle"></i>
                </div>
                <div class="account-shell__avatar-event__picture">
                  <input type="file" id="avatarUpload" class="account-shell__avatar-event__picture-input"
                    (change)="onUploadAvatarEvent($event.target['files'])"
                    [accept]="fileAcceptString">
                  <span class="ui-graphics__balalaika-light" *ngIf="!ProfileAvatar"></span>
                  <img src="{{ProfileAvatar}}" (error)="onAvatarError()" *ngIf="ProfileAvatar">
                  <div class="account-shell__avatar-event__picture-link" (click)="onUploadAvatarHandler()">
                    <div class="grid align-items-center justify-content-center">
                      <i class="pi pi-upload"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="account-shell__avatar-heading">
                <h5>{{Profile.email || Profile.name}}</h5>
              </div>
              <div class="account-shell__avatar-helper">
                <p>Размер не должен превышать 1Mb.<br/>Допустимые типы файлов: jpg, png, gif.</p>
              </div>
            </div>
          </div>

          <div class="col-8 col-sm-12">
            <div class="account-shell__form">

              <div class="grid align-items-end"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
                <div class="col-6 col-sm-12 no-padding">
                  <div class="account-shell__forms-input"
                    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                    <div class="ui-input__placeholder">
                      <p>Имя</p>
                      <span class="require">*</span>
                      <p class="error-holder" *ngIf="ErrorsField.name.status">
                        {{ErrorsField.name.value}}
                      </p>
                    </div>
                    <div class="ui-input ui-input__text"
                      ngClass="{{ErrorsField.name.status ? 'error' : ''}}">
                      <input type="text" placeholder="Имя" formControlName="name">
                    </div>
                  </div>
                </div>
                <div class="col-6 col-sm-12 no-padding">
                  <div class="account-shell__forms-input"
                    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                    <div class="ui-input__placeholder">
                      <p>Фамилия</p>
                      <p class="error-holder" *ngIf="ErrorsField.lastName.status">
                        {{ErrorsField.lastName.value}}
                      </p>
                    </div>
                    <div class="ui-input ui-input__text"
                      ngClass="{{ErrorsField.lastName.status ? 'error' : ''}}">
                      <input type="text" placeholder="Фамилия" formControlName="lastName">
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid align-items-end"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
                <div class="col-6 col-sm-12 no-padding">
                  <div class="account-shell__forms-input"
                    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                    <div class="ui-input__placeholder">
                      <p>E-mail</p>
                      <span class="require">*</span>
                      <p class="error-holder" *ngIf="ErrorsField.email.status">
                        {{ErrorsField.email.value}}
                      </p>
                    </div>
                    <div class="ui-input ui-input__text"
                      ngClass="{{ErrorsField.email.status ? 'error' : ''}}">
                      <input type="text" placeholder="E-mail" formControlName="email"
                        tooltipStyleClass="p-tooltip__input"
                        pTooltip="При изменении email потребуется его повторное подтверждение"
                        tooltipPosition="{{(deviceValue | async) === DTypes.Mobile ? 'bottom' : 'right'}}"
                        hideDelay="0"
                        tooltipEvent="focus">
                    </div>
                  </div>
                </div>
                <div class="col-6 col-sm-12 no-padding">
                  <div class="account-shell__forms-input"
                    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                    <div class="ui-input__placeholder">
                      <p>Дата рождения</p>
                      <p class="error-holder" *ngIf="ErrorsField.birthday.status">
                        {{ErrorsField.birthday.value}}
                      </p>
                    </div>
                    <div class="ui-input ui-input__text"
                      ngClass="{{ErrorsField.birthday.status ? 'error' : ''}}">
                      <div class="ui-input__helper">
                        <div class="ui-input__helper-icon cta" (click)="picker.open()">
                          <span class="mr-icon mr-icon-date"></span>
                        </div>
                      </div>
                      <!--<p-inputMask placeholder="01.01.1991" formControlName="birthday" mask="99.99.9999"></p-inputMask>-->
                      <input type="text" placeholder="01.01.1991" mask="d0.M0.0000" formControlName="birthday"
                        (input)="onSetBirthdayValue($event.target.value)"
                        (blur)="onCheckFormattedDate()">
                      <input type="hidden"
                        [matDatepicker]="picker"
                        [max]="onGetCurrentDate()"
                        (dateChange)="onSetBirthdayValue($event.value, true)">
                      <mat-datepicker touchUi #picker></mat-datepicker>
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid align-items-end"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
                <div class="col-6 col-sm-12 no-padding">
                  <div class="account-shell__forms-input"
                    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                    <div class="ui-input__placeholder">
                      <p>Город</p>
                      <span class="require">*</span>
                      <p class="error-holder" *ngIf="ErrorsField.cityId.status">
                        {{ErrorsField.cityId.value}}
                      </p>
                    </div>
                    <div class="ui-input ui-input__text"
                      ngClass="{{ErrorsField.cityId.status ? 'error' : ''}}">
                      <div class="ui-input__cup cta ui-scroll-horizontal" (click)="onViewSearchCities()">
                        <input type="text" (focus)="onViewSearchCities()" readonly>
                        <span *ngIf="!ProfileCityValue">Выбрать город</span>
                        <p-chip *ngIf="ProfileCityValue"
                          label="{{ProfileCityValue.name}}"
                          styleClass="input__chip">
                        </p-chip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid align-items-start"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
                <div class="col-6 col-sm-12 no-padding">
                  <div class="account-shell__forms-input"
                    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                    <div class="ui-input__placeholder">
                      <p>Телефон</p>
                      <p class="error-holder" *ngIf="ErrorsField.contactPhone.status">
                        {{ErrorsField.contactPhone.value}}
                      </p>
                    </div>
                    <div class="ui-input ui-input__text" formGroupName="contacts"
                      ngClass="{{ErrorsField.contactPhone.status ? 'error' : ''}}">
                      <input type="text" placeholder="+7 (911) 111-11-11"
                        formControlName="contactPhone"
                        mask="+0 (000) 000-00-00"
                        (input)="onMaskPhone($event)"
                        (blur)="onCheckPhone()">
                    </div>
                    <p class="profile-phone__verified txt-caption mt-2" *ngIf="isPhoneVerifiedForDisplay">
                      Телефон подтверждён
                    </p>
                    <p class="profile-phone__confirm txt-caption mt-2" *ngIf="!isPhoneVerifiedForDisplay && onProfilePhoneReadyForConfirm">
                      <span
                        #phoneConfirmBtn
                        class="profile-phone__confirm-link"
                        [class.profile-phone__confirm-link--disabled]="phoneConfirmLoading || !onProfilePhoneReadyForConfirm"
                        role="button"
                        [attr.tabindex]="phoneConfirmLoading || !onProfilePhoneReadyForConfirm ? -1 : 0"
                        (click)="onRequestPhoneConfirm()"
                        (keydown.enter)="onRequestPhoneConfirm()"
                        (keydown.space)="$event.preventDefault(); onRequestPhoneConfirm()">Отправить запрос на подтверждение</span>
                    </p>
                  </div>
                </div>
                <div class="col-6 col-sm-12 no-padding">
                  <div class="account-shell__forms-input"
                    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                    <div class="ui-input__placeholder">
                      <p>Мессенджеры, привязанные к телефону</p>
                    </div>
                    <div class="account-shell__forms-messengers"
                      ngClass="{{onProfileMessengerValid ? '' : 'disabled'}}">
                      <div class="grid align-items-center">
                        <div class="col-auto">
                          <span class="mr-icon mr-icon-telegram-color" (click)="onSetMessengerValue('hasTelegram')"
                            ngClass="{{onGetMessengerStatus('hasTelegram') ? 'selected' : ''}}">
                            <span class="path1"></span>
                            <span class="path2"></span>
                          </span>
                        </div>
                        <div class="col-auto">
                          <span class="mr-icon mr-icon-max-color" (click)="onSetMessengerValue('hasMax')"
                            ngClass="{{onGetMessengerStatus('hasMax') ? 'selected' : ''}}"
                            title="Max">
                            <span class="path1"></span>
                            <span class="path2"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="account-shell__content-wrapper"
        ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pt-8' : 'pl-3 pr-3'}}">
        <div class="account-shell__content-subtitle">
          <h5>Социальные сети</h5>
        </div>
      </div>

      <div class="account-shell__content-wrapper">
        <div class="grid align-items-start justify-content-center">
          <div class="col-12">
            <div class="grid align-items-end"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
              <div class="col-4 col-sm-12 no-padding">
                <div class="account-shell__forms-input"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                  <div class="ui-input__placeholder">
                    <p>VK</p>
                    <p class="error-holder" *ngIf="ErrorsField.vkUsername.status">
                      {{ErrorsField.vkUsername.value}}
                    </p>
                  </div>
                  <div class="ui-input ui-input__text" formGroupName="contacts"
                    ngClass="{{ErrorsField.vkUsername.status ? 'error' : ''}}">
                    <div class="ui-input__helper">
                      <div class="ui-input__helper-icon">
                        <span class="mr-icon mr-icon-vk-color">
                          <span class="path1"></span>
                          <span class="path2"></span>
                        </span>
                      </div>
                    </div>
                    <input type="text" formControlName="vkUsername" placeholder="Ссылка на VK"
                      tooltipStyleClass="p-tooltip__input"
                      pTooltip="Пример ссылки на VK: «vk.com/musicians_russia»"
                      tooltipPosition="bottom"
                      hideDelay="0"
                      tooltipEvent="focus"
                      (blur)="onCheckSocial('vkUsername')">
                  </div>
                </div>
              </div>

              <!--<div class="col-4 col-sm-12 no-padding">
                <div class="account-shell__forms-input"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">

                  <div class="ui-input__placeholder">
                    <p>Facebook</p>
                    <p class="error-holder" *ngIf="ErrorsField.facebookUsername.status">
                      {{ErrorsField.facebookUsername.value}}
                    </p>
                  </div>
                  <div class="ui-input ui-input__text" formGroupName="contacts"
                    ngClass="{{ErrorsField.facebookUsername.status ? 'error' : ''}}">
                    <div class="ui-input__helper">
                      <div class="ui-input__helper-icon">
                          <span class="mr-icon mr-icon-fb-color">
                            <span class="path1"></span>
                            <span class="path2"></span>
                          </span>
                      </div>
                    </div>
                    <input type="text" formControlName="facebookUsername" placeholder="Ссылка на Facebook"
                      tooltipStyleClass="p-tooltip__input"
                      pTooltip="Пример ссылки на Facebook: «fb.com/rusmuzikant»"
                      tooltipPosition="bottom"
                      hideDelay="0"
                      tooltipEvent="focus"
                      (blur)="onCheckSocial('facebookUsername')">
                  </div>
                </div>
              </div>-->

              <div class="col-4 col-sm-12 no-padding">
                <div class="account-shell__forms-input"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">

                  <div class="ui-input__placeholder">
                    <p>Instagram</p>
                    <p class="error-holder" *ngIf="ErrorsField?.instagramUsername?.status">
                      {{ErrorsField?.instagramUsername?.value}}
                    </p>
                  </div>
                  <div class="ui-input ui-input__text" formGroupName="contacts"
                    ngClass="{{ErrorsField?.instagramUsername?.status ? 'error' : ''}}">
                    <div class="ui-input__helper">
                      <div class="ui-input__helper-icon">
                          <span class="mr-icon mr-icon-inst-color">
                            <span class="path1"></span>
                            <span class="path2"></span>
                            <span class="path3"></span>
                            <span class="path4"></span>
                          </span>
                      </div>
                    </div>
                    <input type="text" formControlName="instagramUsername" placeholder="Ссылка на Instagram"
                      tooltipStyleClass="p-tooltip__input"
                      pTooltip="Пример ссылки на Instagram: «musicians_of_russia»"
                      tooltipPosition="bottom"
                      hideDelay="0"
                      tooltipEvent="focus"
                      (blur)="onCheckSocial('instagramUsername')">
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="hasMusicianRole">
        <div class="account-shell__content-wrapper"
          ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pt-8' : 'pl-3 pr-3'}}">
          <div class="account-shell__content-subtitle">
            <h5>Музыкант</h5>
          </div>
        </div>
        <div class="account-shell__content-wrapper">
          <div class="grid align-items-start justify-content-center">
            <div class="col-12">
              <div class="grid align-items-end"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
                <div class="col-8 col-sm-12 no-padding">
                  <div class="account-shell__forms-input"
                    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                    <div class="ui-input__placeholder">
                      <p>Ваш инструмент или должность</p>
                      <span class="require">*</span>
                      <p class="error-holder" *ngIf="ErrorsField.instrumentIds.status">
                        {{ErrorsField.instrumentIds.value}}
                      </p>
                    </div>
                    <div class="ui-input ui-input__text"
                      ngClass="{{ErrorsField.instrumentIds.status ? 'error' : ''}}">
                      <div class="ui-input__cup cta ui-scroll-horizontal" (click)="onViewSearchActivity()">
                        <span *ngIf="!ProfileActivityPosition && !ProfileActivityInstruments.length">
                          Выбрать инструмент или должность
                        </span>
                        <div class="grid align-items-center flex-nowrap "
                          *ngIf="ProfileActivityPosition || ProfileActivityInstruments.length">
                          <p-chip *ngIf="ProfileActivityPosition"
                            label="{{ProfileActivityPosition.title}}"
                            styleClass="input__chip">
                          </p-chip>
                          <ng-container *ngFor="let instrument of ProfileActivityInstruments">
                            <p-chip label="{{instrument.title}}" styleClass="input__chip"></p-chip>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="hasBookingCustomerRole">
        <div class="account-shell__content-wrapper"
          ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pt-8' : 'pl-3 pr-3'}}">
          <div class="account-shell__content-subtitle">
            <h5>Частный заказчик</h5>
          </div>
        </div>
        <div class="account-shell__content-wrapper" *ngIf="bookingCustomerProfileLoading">
          <div class="grid justify-content-center py-4">
            <div class="ui-loader ui-loader__page-light"></div>
          </div>
        </div>
        <div class="account-shell__content-wrapper pl-3 pr-3" *ngIf="!bookingCustomerProfileLoading && !bookingCustomerForm && bookingCustomerProfileLoadError">
          <p class="txt-caption profile-user__booking-customer-error">{{ bookingCustomerProfileLoadError }}</p>
        </div>
        <ng-container *ngIf="!bookingCustomerProfileLoading && bookingCustomerForm as bcForm">
          <div class="account-shell__content-wrapper profile-user__booking-customer" [formGroup]="bcForm">
            <div class="grid align-items-start justify-content-center"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : ''}}">
              <div class="col-4 col-sm-12">
                <div class="account-shell__avatar mb-4">
                  <div class="account-shell__avatar-event">
                    <div class="account-shell__avatar-event__picture">
                      <input type="file" id="bookingCustomerAvatarUpload" class="account-shell__avatar-event__picture-input"
                        (change)="onUploadBookingCustomerAvatarEvent($event.target['files'])"
                        [accept]="fileAcceptString">
                      <span class="ui-graphics__balalaika-light" *ngIf="!bookingCustomerAvatar"></span>
                      <img [src]="bookingCustomerAvatar" (error)="onBookingCustomerAvatarError()" *ngIf="bookingCustomerAvatar">
                      <div class="account-shell__avatar-event__picture-link" (click)="onUploadBookingCustomerAvatarHandler()">
                        <div class="grid align-items-center justify-content-center">
                          <i class="pi pi-upload"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="account-shell__avatar-helper">
                    <p>Размер не должен превышать 1Mb.<br/>Допустимые типы файлов: jpg, png, gif.</p>
                  </div>
                </div>
              </div>
              <div class="col-8 col-sm-12 no-padding">
                <div class="grid align-items-start"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
                  <div class="col-6 col-sm-12 no-padding">
                    <div class="account-shell__forms-input"
                      ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                      <div class="ui-input__placeholder">
                        <p>Имя в профиле заказчика</p>
                      </div>
                      <div class="ui-input ui-input__text" [class.error]="bcForm.get('name').invalid && (bcForm.get('name').touched || bookingCustomerFormSubmitted)">
                        <input type="text" formControlName="name" placeholder="Как к вам обращаться" maxlength="200" />
                      </div>
                      <p class="error-holder" *ngIf="bcForm.get('name').invalid && (bcForm.get('name').touched || bookingCustomerFormSubmitted)">Не более 200 символов</p>
                    </div>
                  </div>
                  <div class="col-6 col-sm-12 no-padding">
                    <div class="account-shell__forms-input"
                      ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-2 pr-2'}}">
                      <div class="ui-input__placeholder">
                        <p>Город</p>
                        <span class="require">*</span>
                      </div>
                      <div class="ui-input ui-input__text"
                        [class.error]="bcForm.get('cityId').invalid && (bcForm.get('cityId').touched || bookingCustomerFormSubmitted)">
                        <div class="ui-input__cup cta ui-scroll-horizontal" (click)="onViewBookingCustomerSearchCities()">
                          <input class="profile-user__city-input" type="text" (focus)="onViewBookingCustomerSearchCities()" readonly>
                          <span *ngIf="!BookingCustomerCityValue">Выбрать город</span>
                          <p-chip *ngIf="BookingCustomerCityValue"
                            [label]="BookingCustomerCityValue.name"
                            styleClass="input__chip">
                          </p-chip>
                        </div>
                      </div>
                      <p class="error-holder" *ngIf="bcForm.get('cityId').invalid && (bcForm.get('cityId').touched || bookingCustomerFormSubmitted)">Выберите город</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="account-shell__content-subtitle pt-2 pb-2"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pl-2 pr-2' : ''}}">
              <h6 class="m-0">Ссылки на соцсети <span class="require">*</span></h6>
            </div>
            <div class="grid align-items-start justify-content-center" formArrayName="socialLinks">
              <div class="col-12">
                <p class="txt-caption profile-user__booking-customer-error mb-3" *ngIf="bookingCustomerSaveError">{{ bookingCustomerSaveError }}</p>
                <div
                  *ngFor="let c of bookingCustomerSocialLinksArray.controls; let i = index; trackBy: trackByBookingSocialIndex"
                  [formGroupName]="i"
                  class="profile-user__booking-customer-social-row"
                  [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'profile-user__booking-customer-social-row--stack' : ''">
                  <div class="profile-user__booking-customer-social-platform" [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'pl-2 pr-2' : 'pr-2'">
                    <p-dropdown
                      [options]="SocialPlatforms"
                      optionLabel="name"
                      optionValue="value"
                      formControlName="platform"
                      styleClass="p-dropdown__bulletins"
                      [placeholder]="'Платформа'"
                      [showClear]="false">
                      <ng-template let-platform pTemplate="item">
                        <div class="profile-user__booking-customer-platform-option">
                          <span *ngIf="getBookingPlatformIcon(platform.value).type === 'font'" [class]="getBookingPlatformIcon(platform.value).iconClass" class="profile-user__booking-customer-platform-icon-font">
                            <span class="path1"></span><span class="path2"></span><span class="path3" *ngIf="getBookingPlatformIcon(platform.value).paths >= 3"></span><span class="path4" *ngIf="getBookingPlatformIcon(platform.value).paths >= 4"></span>
                          </span>
                          <img *ngIf="getBookingPlatformIcon(platform.value).type === 'svg'" [src]="getBookingPlatformIcon(platform.value).src" class="profile-user__booking-customer-platform-icon-img" alt="">
                          <span class="profile-user__booking-customer-platform-name">{{ platform.name }}</span>
                        </div>
                      </ng-template>
                      <ng-template let-platform pTemplate="selectedItem">
                        <div class="profile-user__booking-customer-platform-option" *ngIf="platform; else pbcPlatformPlaceholder">
                          <span *ngIf="getBookingPlatformIcon(platform.value).type === 'font'" [class]="getBookingPlatformIcon(platform.value).iconClass" class="profile-user__booking-customer-platform-icon-font">
                            <span class="path1"></span><span class="path2"></span><span class="path3" *ngIf="getBookingPlatformIcon(platform.value).paths >= 3"></span><span class="path4" *ngIf="getBookingPlatformIcon(platform.value).paths >= 4"></span>
                          </span>
                          <img *ngIf="getBookingPlatformIcon(platform.value).type === 'svg'" [src]="getBookingPlatformIcon(platform.value).src" class="profile-user__booking-customer-platform-icon-img" alt="">
                          <span class="profile-user__booking-customer-platform-name">{{ platform.name }}</span>
                        </div>
                        <ng-template #pbcPlatformPlaceholder>Платформа</ng-template>
                      </ng-template>
                    </p-dropdown>
                  </div>
                  <div class="profile-user__booking-customer-social-url pl-2 pr-2">
                    <div class="ui-input ui-input__text" [class.error]="c.get('url').invalid && (c.get('url').touched || bookingCustomerFormSubmitted)">
                      <input type="url" formControlName="url" placeholder="https://" />
                    </div>
                    <p class="error-holder" *ngIf="c.get('url').invalid && (c.get('url').touched || bookingCustomerFormSubmitted)">Некорректный URL</p>
                  </div>
                  <div class="profile-user__booking-customer-social-remove">
                    <button type="button" class="ui-buttons ui-buttons__light-small profile-user__booking-customer-social-remove-btn" (click)="removeBookingCustomerSocialLink(i)" [attr.aria-label]="'Удалить ссылку'">
                      <i class="pi pi-times"></i>
                    </button>
                  </div>
                </div>
                <button type="button" class="ui-buttons ui-buttons__light-small mt-2" (click)="addBookingCustomerSocialLink()">Добавить ссылку</button>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <div class="account-shell__content-wrapper">
        <div class="account-shell__content-errors __profile__errors">
          <div class="grid justify-content-center"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'align-items-center text-left' : 'align-items-baseline'}}">
            <span class="mr-icon mr-icon-status-error"></span>
            <p>{{ErrorsText}}</p>
          </div>
        </div>
        <div class="account-shell__content-button">
          <div class="grid align-items-center justify-content-center">
            <div class="col-3 col-sm-6">
              <button class="ui-buttons ui-buttons__blue-large" (click)="onSaveProfile()"
                ngClass="{{ProfileFormModify ? '' : 'disabled'}}">
                Сохранить
              </button>
            </div>
          </div>
        </div>
      </div>

    </form>

    <p-confirmDialog [key]="'profileUserRoles'" [appendTo]="'body'" [styleClass]="'p-dialog__confirm'">
    </p-confirmDialog>
  </div>
</div>
